/**
 * News V3 — saved priorities / watchlist (insights v2).
 */
import api from '../utils/api';

const base = '/api/insights/v2';

export async function getNewsWatchlist() {
  const res = await api.get(`${base}/watchlist`);
  return res.data;
}

export async function addNewsWatchlistItem(payload) {
  const res = await api.post(`${base}/watchlist`, payload);
  return res.data;
}

export async function removeNewsWatchlistItem(id) {
  const res = await api.delete(`${base}/watchlist/${encodeURIComponent(id)}`);
  return res.data;
}
